import React from "react";
import { useTranslation } from "react-i18next";
import HelpdeskIcon from "@icons/myicons/sidebar/help-circle.svg?react";
import { MandatorConditional } from "@helpers";
import { MenuItem } from "@components";

// The helpdesk is a separate deployment that only exists on the mandator hosts
// that have one, so the URL is per build and the item disappears without it.
const helpdeskUrl: string | undefined = import.meta.env.VITE_APP_HELPDESK_URL;

export const HelpdeskMenuItem = () => {
  const { t } = useTranslation();

  if (!helpdeskUrl) return null;

  return (
    <MandatorConditional showFor={["kpmg-germany"]}>
      <MenuItem
        to={helpdeskUrl}
        name={t("appSidebar.menu.helpdesk")}
        before={<HelpdeskIcon />}
      />
    </MandatorConditional>
  );
};
